// Enums centralisés (identique à functions)
export enum UserRole {
  ADMIN = "ADMIN",
  SUPPORT = "SUPPORT",
  COLLABORATEUR = "COLLABORATEUR",
  FOURNISSEUR = "FOURNISSEUR",
  /** Consultation seule. Prevu pour les agents automatiques. */
  LECTEUR = "LECTEUR",
}

export enum OrderStatus {
  PENDING = "PENDING",
  GLOVO_ACCEPTED = "GLOVO_ACCEPTED",
  IN_PREPARATION = "IN_PREPARATION",
  GLOVO_READY = "GLOVO_READY",
  GLOVO_DELIVERED = "GLOVO_DELIVERED",
  CANCELLED = "CANCELLED",
  GLOVO_CANCELLED = "GLOVO_CANCELLED",
}

export enum BasketStatus {
  PENDING = "PENDING",
  PREPARING = "PREPARING",
  READY = "READY",
  PICKED_UP = "PICKED_UP",
  CANCELLED = "CANCELLED",
}

export enum FournisseurCategory {
  VIANDE = "VIANDE",
  VOLAILLE = "VOLAILLE",
  LEGUMES = "LEGUMES",
  FRUITS = "FRUITS",
  EPICERIE = "EPICERIE",
  AUTRE = "AUTRE",
}

export enum InvoiceStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export enum OrderSource {
  GLOVO = "GLOVO",
  WEBSITE = "WEBSITE",
  YASSIR = "YASSIR",
  OTHER = "OTHER",
}

// Direction des messages
export enum MessageDirection {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

// Collections Firestore
export const COLLECTIONS = {
  USERS: "users",
  STORES: "stores",
  COLLABORATEURS: "collaborateurs",
  FOURNISSEURS: "fournisseurs",
  PRODUCTS: "products",
  PRODUCT_PRICES: "productPrices",
  ORDERS: "orders",
  ORDER_ITEMS: "orderItems",
  SUPPLIER_BASKETS: "supplierBaskets",
  CATEGORIES: "categories",
  CATEGORY_PRICING: "categoryPricing",
  SUPPLIER_INVOICES: "supplierInvoices",
  SUPPLIER_INVOICE_ITEMS: "supplierInvoiceItems",
  NOTIFICATIONS: "notifications",
  SETTINGS: "settings",
  // Messaging
  CONVERSATIONS: "conversations",
  MESSAGES: "messages",
  AUTO_MESSAGES: "autoMessages", // 🆕 Messages automatiques WhatsApp
  // Email Parsing & Customers
  EMAIL_ORDERS: "emailOrders",
  CUSTOMERS: "customers",
  STATS: "stats",
} as const;

// Labels pour les statuts
export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  [OrderStatus.PENDING]: "En attente",
  [OrderStatus.GLOVO_ACCEPTED]: "Acceptée (Glovo)",
  [OrderStatus.IN_PREPARATION]: "En préparation",
  [OrderStatus.GLOVO_READY]: "Prête (Glovo)",
  [OrderStatus.GLOVO_DELIVERED]: "Livrée",
  [OrderStatus.CANCELLED]: "Annulée",
  [OrderStatus.GLOVO_CANCELLED]: "Annulée (Glovo)",
};

export const BASKET_STATUS_LABELS: Record<BasketStatus, string> = {
  [BasketStatus.PENDING]: "En attente",
  [BasketStatus.PREPARING]: "En préparation",
  [BasketStatus.READY]: "Prêt",
  [BasketStatus.PICKED_UP]: "Récupéré",
  [BasketStatus.CANCELLED]: "Annulé",
};

export const CATEGORY_LABELS: Record<FournisseurCategory, string> = {
  [FournisseurCategory.VIANDE]: "Viande",
  [FournisseurCategory.VOLAILLE]: "Volaille",
  [FournisseurCategory.LEGUMES]: "Légumes",
  [FournisseurCategory.FRUITS]: "Fruits",
  [FournisseurCategory.EPICERIE]: "Épicerie",
  [FournisseurCategory.AUTRE]: "Autre",
};

/** Codes `cancel_reason` / webhook Glovo → libellé affichage (FR) */
export const GLOVO_CANCEL_REASON_LABELS: Record<string, string> = {
  PRODUCTS_NOT_AVAILABLE: "Produits non disponibles",
  STORE_CLOSED: "Magasin fermé",
  CUSTOMER_UNREACHABLE: "Client injoignable",
  COURIER_UNREACHABLE: "Livreur injoignable",
  DUPLICATE_ORDER: "Commande en double",
  PAYMENT_FAILED: "Paiement échoué",
  WEATHER_CONDITIONS: "Conditions météo",
  OTHER: "Autre",
};
